export default __webpack_public_path__ + "static/media/cobraking3.ce612ddf.jpg";